module.exports = __webpack_public_path__ + "img/a123-1.d08ae073.webp";